import {
  MenuItem,
  Select,
  TextField
} from "@material-ui/core";
import InputLabel from "@material-ui/core/InputLabel";
import TableRow from "@material-ui/core/TableRow";
import CheckIcon from "@material-ui/icons/Check";
import ColorButton from "components/common/ColorButton";
import {
  useAddress
} from "components/ltr-request-document/components/AddressCompany";
import {
  StyledTableCell,
  useStyles
} from "components/request-document/components/Commons";
import useModalLoading from "libs/hooks/useModalLoading";
import { getErrorMessage, isError } from "libs/utils/form";
import { get } from "lodash";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { canEditForm } from "redux/modules/authSlice";
import {
  checkCompany,
  companySlice,
  selectCheckCompany
} from "redux/modules/companySlice";
import { selectMasterData } from "redux/modules/masterSlice";
import { selectCurrentDocument } from "redux/modules/visaForm";

export default function CompanyInfoSection({
  formik,
  colSpan = 3,
  mapField = (str) => str,
  disabledBadge = false,
  isChangeMode = false,
  ConditionType,
  disabled = false
}) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [firstTimeChecked, setFirstTimeChecked] = useState(false);
  const { showLoading, hideLoading } = useModalLoading();
  const { isLoading } = useSelector(selectCurrentDocument);
  const { isSuccess, isFailure, data, error } = useSelector(selectCheckCompany);
  const canEdit = useSelector(canEditForm);
  const WPCompanyRegisterNumber =
    formik.values.document.WPCompanyRegisterNumber;
  const addressFieldOptions = useAddress({
    formik,
    ProvinceFieldName: "document.emp_province_ddl",
    DistrictFieldName: "document.emp_district_ddl",
    SubDistrictFieldName: "document.emp_subdistrict_ddl",
  });
  const masterData = useSelector(selectMasterData);

  // console.log(masterData);
  const companyTypeConfig = get(masterData, "companyTypeConfig", []);
  const enterprisesConfig = get(masterData, "enterprisesConfig", []);

  useEffect(() => {
    if (!firstTimeChecked) {
      dispatch(companySlice.actions.clearAll());
    }
  }, [firstTimeChecked]);

  useEffect(() => {
    if (isSuccess || isFailure) {
      hideLoading();

      if (isSuccess) {
        formik.setFieldValue(
          "document.WPCompanyRegisterNumber",
          WPCompanyRegisterNumber
        );
        formik.setFieldValue("document.WPCompanyName", data.companyName);
        formik.setFieldValue("document.WPCompanyAddress", data.address);
        formik.setFieldValue("document.WPCompanyOfficeNumber", data.phone);
        formik.setFieldValue("document.WPCompanyWebsite", data.email);
        formik.setFieldValue("document.WPCompanyProductsServices", data.desc);
      }
    }
  }, [isSuccess, isFailure]);

  useEffect(() => {
    if (isLoading) return;

    if (WPCompanyRegisterNumber && !firstTimeChecked) {
      showLoading();
      dispatch(checkCompany(WPCompanyRegisterNumber));
      setFirstTimeChecked(true);
    } else if (!firstTimeChecked) {
      setFirstTimeChecked(true);
    }
  }, [WPCompanyRegisterNumber, firstTimeChecked, isLoading]);

  const handleOnCheck = async () => {
    showLoading();
    dispatch(checkCompany(WPCompanyRegisterNumber));
  };

  return (
    <>
      <TableRow>
        <StyledTableCell colSpan={7}>
          <div className={classes.cellContent}>
            <div className={classes.flexRow} style={{ width: "100%" }}>
              <div className={classes.wrapField} style={{ marginRight: 15 }}>
                <InputLabel>Company Type</InputLabel>

                <Select
                  label="Select Company Type"
                  variant="outlined"
                  name="document.companyType"
                  value={formik.values.document.companyType}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  className={classes.textField}
                  disabled={disabled || !canEdit}
                >
                  {companyTypeConfig.map((x) => (
                    <MenuItem value={x?.companyTypeID} key={x?.companyTypeID}>
                      {x?.companyTypeName}
                    </MenuItem>
                  ))}
                </Select>
              </div>
            </div>
          </div>
        </StyledTableCell>
      </TableRow>
      {formik.values.document.companyType === "C" && (
        <>
          <TableRow>
            <StyledTableCell colSpan={colSpan - 2}>
              <div className={classes.cellContent}>
                <div className={classes.flexRow} style={{ width: "100%" }}>
                  <div
                    className={classes.wrapField}
                    style={{ marginRight: 15 }}
                  >
                    <InputLabel>Registered number</InputLabel>
                    <TextField
                      disabled={disabled || !canEdit}
                      variant="outlined"
                      className={classes.textField}
                      InputProps={{
                        classes: {
                          root: isSuccess
                            ? classes.textFieldSuccess
                            : undefined,
                          notchedOutline: isSuccess
                            ? classes.notchedOutlineSuccess
                            : undefined,
                        },
                        endAdornment: isSuccess ? <CheckIcon /> : null,
                      }}
                      FormHelperTextProps={{
                        classes: {
                          root: isSuccess ? classes.textSuccess : undefined,
                        },
                      }}
                      // type="number"
                      name="document.WPCompanyRegisterNumber"
                      value={formik.values.document.WPCompanyRegisterNumber}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={isFailure}
                      helperText={isSuccess ? "success" : error?.message || " "}
                    />
                  </div>

                  <ColorButton
                    color="primary"
                    variant="contained"
                    disabled={disabled || !canEdit}
                    onClick={handleOnCheck}
                  >
                    Check
                  </ColorButton>
                </div>
              </div>
            </StyledTableCell>

            <StyledTableCell colSpan={2}>
              <div className={classes.cellContent}>
                <div className={classes.wrapField}>
                  <InputLabel>Company name</InputLabel>
                  <TextField
                    variant="outlined"
                    className={classes.textField}
                    name="document.WPCompanyName"
                    value={formik.values.document.WPCompanyName}
                    onChange={isChangeMode ? undefined : formik.handleChange}
                    onBlur={isChangeMode ? undefined : formik.handleBlur}
                    error={isError("document.WPCompanyName", formik)}
                    helperText={getErrorMessage(
                      "document.WPCompanyName",
                      formik
                    )}
                    disabled={
                      disabled ||
                      (!isSuccess
                        ? true
                        : isChangeMode
                          ? ConditionType !== "CN"
                          : true || !canEdit)
                    }
                  />
                </div>
              </div>
            </StyledTableCell>
          </TableRow>

          <TableRow>
            <StyledTableCell colSpan={2} rowSpan={2}>
              <div className={classes.cellContent}>
                <div className={classes.wrapField}>
                  <InputLabel>Address</InputLabel>
                  <TextField
                    variant="outlined"
                    className={classes.textField}
                    name="document.WPCompanyAddress"
                    value={formik.values.document.WPCompanyAddress}
                    onChange={isChangeMode ? undefined : formik.handleChange}
                    onBlur={isChangeMode ? undefined : formik.handleBlur}
                    error={isError("document.WPCompanyAddress", formik)}
                    helperText={getErrorMessage(
                      "document.WPCompanyAddress",
                      formik
                    )}
                    disabled={
                      disabled || (!isSuccess
                        ? true
                        : isChangeMode
                          ? ConditionType !== "CA"
                          : true)
                    }
                    multiline
                    rows={5}
                    rowsMin={5}
                    rowsMax={5}
                  />
                </div>
              </div>
            </StyledTableCell>
            <StyledTableCell colSpan={colSpan - 2}>
              <div className={classes.cellContent}>
                <div className={classes.wrapField}>
                  <InputLabel>Office number</InputLabel>
                  <TextField
                    variant="outlined"
                    className={classes.textField}
                    name="document.WPCompanyOfficeNumber"
                    value={formik.values.document.WPCompanyOfficeNumber}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={isError("document.WPCompanyOfficeNumber", formik)}
                    helperText={getErrorMessage(
                      "document.WPCompanyOfficeNumber",
                      formik
                    )}
                    disabled={disabled || !canEdit}
                  />
                </div>
              </div>
            </StyledTableCell>
          </TableRow>
          <TableRow>
            <StyledTableCell colSpan={colSpan - 2}>
              <div className={classes.cellContent}>
                <div className={classes.wrapField}>
                  <InputLabel>Company website or e-mail address</InputLabel>
                  <TextField
                    variant="outlined"
                    className={classes.textField}
                    name="document.WPCompanyWebsite"
                    value={formik.values.document.WPCompanyWebsite}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={isError(mapField("WPCompanyWebsite"), formik)}
                    helperText={getErrorMessage(
                      "document.WPCompanyWebsite",
                      formik
                    )}
                    disabled={disabled || !canEdit}
                  />
                </div>
              </div>
            </StyledTableCell>
          </TableRow>
          <TableRow>
            <StyledTableCell colSpan={colSpan}>
              <InputLabel>
                Business or products or services description
              </InputLabel>
              <TextField
                disabled={disabled || !canEdit}
                variant="outlined"
                className={classes.textField}
                name="document.WPCompanyProductsServices"
                value={formik.values.document.WPCompanyProductsServices}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={isError("document.WPCompanyProductsServices", formik)}
                helperText={getErrorMessage(
                  "document.WPCompanyProductsServices",
                  formik
                )}
                multiline
                rows={5}
                rowsMin={5}
                rowsMax={5}
              />
            </StyledTableCell>
          </TableRow>
        </>
      )}
      {formik.values.document.companyType === "E" && (
        <>
          <TableRow>
            <StyledTableCell colSpan={7}>
              <div className={classes.cellContent}>
                <div className={classes.flexRow} style={{ width: "100%" }}>
                  <div
                    className={classes.wrapField}
                    style={{ marginRight: 15 }}
                  >
                    <InputLabel>Enterprises</InputLabel>

                    <Select
                      variant="outlined"
                      name="document.emp_idcard_no"
                      value={formik.values.document.emp_idcard_no}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={isError("document.emp_idcard_no", formik)}
                      helperText={getErrorMessage(
                        "document.emp_idcard_no",
                        formik
                      )}
                      disabled={disabled || !canEdit}
                    >
                      {enterprisesConfig?.map((x) => (
                        <MenuItem
                          value={x?.enterprisesID}
                          key={x?.enterprisesID}
                        >
                          {x?.enterprisesNameEN}
                        </MenuItem>
                      ))}
                    </Select>
                    {/* <TextField
                      variant="outlined"
                      className={classes.textField}
                      name="document.emp_idcard_no"
                      value={formik.values.document.emp_idcard_no}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={isError("document.emp_idcard_no", formik)}
                      helperText={getErrorMessage(
                        "document.emp_idcard_no",
                        formik
                      )}
                    /> */}
                  </div>
                </div>
              </div>
            </StyledTableCell>
          </TableRow>
        </>

        // <>
        //   <TableRow>
        //     <StyledTableCell colSpan={colSpan - 2}>
        //       <div className={classes.cellContent}>
        //         <div className={classes.flexRow} style={{ width: "100%" }}>
        //           <div
        //             className={classes.wrapField}
        //             style={{ marginRight: 15 }}
        //           >
        //             <InputLabel>ID Card No.</InputLabel>
        //             <TextField
        //               variant="outlined"
        //               className={classes.textField}
        //               name="document.emp_idcard_no"
        //               value={formik.values.document.emp_idcard_no}
        //               onChange={formik.handleChange}
        //               onBlur={formik.handleBlur}
        //               error={isError("document.emp_idcard_no", formik)}
        //               helperText={getErrorMessage(
        //                 "document.emp_idcard_no",
        //                 formik
        //               )}
        //             />
        //           </div>
        //         </div>
        //       </div>
        //     </StyledTableCell>

        //     <StyledTableCell colSpan={2}>
        //       <div className={classes.cellContent}>
        //         <div className={classes.wrapField}>
        //           <InputLabel>Employer name</InputLabel>
        //           <TextField
        //             variant="outlined"
        //             className={classes.textField}
        //             name="document.emp_fullname"
        //             value={formik.values.document.emp_fullname}
        //             onChange={formik.handleChange}
        //             onBlur={formik.handleBlur}
        //             error={isError("document.emp_fullname", formik)}
        //             helperText={getErrorMessage(
        //               "document.emp_fullname",
        //               formik
        //             )}
        //           />
        //         </div>
        //       </div>
        //     </StyledTableCell>
        //   </TableRow>

        //   <TableRow>
        //     <StyledTableCell colSpan={2} rowSpan={2}>
        //       <div className={classes.cellContent}>
        //         <div className={classes.wrapField}>
        //           <InputLabel>Address</InputLabel>
        //           <TextField
        //             variant="outlined"
        //             className={classes.textField}
        //             name="document.emp_address"
        //             value={formik.values.document.emp_address}
        //             onChange={formik.handleChange}
        //             onBlur={formik.handleBlur}
        //             error={isError("document.emp_address", formik)}
        //             helperText={getErrorMessage("document.emp_address", formik)}
        //             multiline
        //             rows={5}
        //             rowsMin={5}
        //             rowsMax={5}
        //           />
        //         </div>
        //       </div>
        //     </StyledTableCell>
        //   </TableRow>
        //   <TableRow>
        //     <StyledTableCell colSpan={colSpan}>
        //       <div className={classes.cellContent}>
        //         <div className={classes.wrapField}>
        //           <FormGroup row>
        //             <div className={classes.wrapField}>
        //               <ProvinceField {...addressFieldOptions} />
        //             </div>
        //           </FormGroup>
        //           <FormGroup row>
        //             <div
        //               className={classes.wrapField}
        //               style={{ marginRight: 5 }}
        //             >
        //               <DistrictField {...addressFieldOptions} />
        //             </div>
        //             <div
        //               className={classes.wrapField}
        //               style={{ marginRight: 5 }}
        //             >
        //               <SubDistrictField {...addressFieldOptions} />
        //             </div>
        //             {/* <div className={classes.wrapField}>
        //               <ZipcodeField {...addressFieldOptions} />
        //             </div> */}
        //           </FormGroup>
        //         </div>
        //       </div>
        //     </StyledTableCell>
        //   </TableRow>
        //   <TableRow>
        //     <StyledTableCell colSpan={8}>
        //       <div className={classes.cellContent}>
        //         <div className={classes.wrapField}>
        //           <InputLabel>Tel</InputLabel>
        //           <TextField
        //             variant="outlined"
        //             className={classes.textField}
        //             name="document.emp_tel"
        //             value={formik.values.document.emp_tel}
        //             onChange={formik.handleChange}
        //             onBlur={formik.handleBlur}
        //             error={isError(mapField("emp_tel"), formik)}
        //             helperText={getErrorMessage("document.emp_tel", formik)}
        //           />
        //         </div>
        //       </div>
        //     </StyledTableCell>
        //   </TableRow>
        // </>
      )}
    </>
  );
}
